import Vue from 'vue'
import VueCarousel from 'vue-carousel'

import App from './App'
import router from './router'
import { store } from './store/store'

import vuetify from './plugins/vuetify'
import '@/plugins/components'
import '@/plugins/mixins'
import '@/plugins/filters'

// loading layout
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

// PUBNUB
import PubNubVue from 'pubnub-vue'

import i18n from './plugins/i18n'

// import { ApmVuePlugin } from '@elastic/apm-rum-vue'

import * as Sentry from "@sentry/vue";

Vue.use(Loading)

Vue.use(VueCarousel)

Vue.config.productionTip = false

import VueTrumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';
Vue.use(VueTrumbowyg);

window.addEventListener('dragover', function (e) {
  e.preventDefault()
  e.dataTransfer.effectAllowed = 'none'
  e.dataTransfer.dropEffect = 'none'
}, false)

window.addEventListener('drop', function (e) {
  e.preventDefault()
  e.dataTransfer.effectAllowed = 'none'
  e.dataTransfer.dropEffect = 'none'
}, false)

window.OneSignal = window.OneSignal || []
let initConfig = {
  appId: "133592ad-44e0-4114-a882-304b0c37ed58",
  subdomainName: "your_label", /* The label for your site that you added in Site Setup mylabel.os.tc */
  promptOptions: {
    /* Change bold title, limited to 30 characters */
    siteName: 'OneSignal Documentation',
    /* Subtitle, limited to 90 characters */
    actionMessage: "We'd like to show you notifications for the latest news and updates.",
    /* Example notification title */
    exampleNotificationTitle: 'Example notification',
    /* Example notification message */
    exampleNotificationMessage: 'This is an example notification',
    /* Text below example notification, limited to 50 characters */
    exampleNotificationCaption: 'You can unsubscribe anytime',
    /* Accept button text, limited to 15 characters */
    acceptButtonText: "ALLOW",
    /* Cancel button text, limited to 15 characters */
    cancelButtonText: "NO THANKS",
    autoAcceptTitle: 'Click Allow'
  }
}
window.OneSignal.push(async function() {
    window.OneSignal.SERVICE_WORKER_PARAM = { scope: process.env.BASE_URL };
    window.OneSignal.SERVICE_WORKER_PATH =  process.env.BASE_URL + 'OneSignalSDKWorker.js'
    window.OneSignal.SERVICE_WORKER_UPDATER_PATH = process.env.BASE_URL + 'OneSignalSDKUpdaterWorker.js'
    window.OneSignal.init(initConfig);
  // await window.OneSignal.showHttpPrompt()
  await window.OneSignal.on('notificationPermissionChange', function(permissionChange) {
    if (permissionChange.to === 'granted') {
      window.OneSignal.getNotificationPermission(function(permission) {
        if (permission) {
          console.log('in')
          window.OneSignal.setSubscription(true)
        }
      })
    }
  })
})
// window.OneSignal.push(function() {
//   window.OneSignal.on('notificationPermissionChange', function(permissionChange) {
//     if (permissionChange.to === 'granted') {
//       console.log('on')
//     }
//     window.OneSignal.isPushNotificationsEnabled(function(isEnabled) {
//       if (isEnabled) {
//         console.log('in')
//         window.OneSignal.setSubscription()
//       }
//     })
//   })
// })
Vue.config.productionTip = false

const publishKey = 'pub-c-72939dfa-99d7-41ad-87f7-3b2713474c96'
const subscribeKey = 'sub-c-04b51a38-5a1c-11ea-8216-b6c21e45eadc'

// Make a unique uuid for each client
const myUuid = getUuid()
const me = {
  uuid: myUuid
}

console.log('pn uuid', myUuid) 

try {
  if (!publishKey || !subscribeKey) {
    // eslint-disable-next-line
    throw 'PubNub Keys are missing.'
  }
} catch (err) {
  console.log(err)
}

Vue.use(PubNubVue, {
  subscribeKey: subscribeKey,
  publishKey: publishKey,
  ssl: true,
  uuid: myUuid
}, store)

function getUuid () {
  // Obtener el UUID del localStorage o generar uno nuevo
  let uuid = localStorage.getItem('uuid');
  
  // Si no existe, crear uno nuevo
  if (!uuid) {
    // Generar un número aleatorio de 6 dígitos
    uuid = Math.floor(100000 + Math.random() * 900000).toString();
    
    // Guardar en localStorage
    localStorage.setItem('uuid', uuid);
  }
  
  // Devolver el UUID
  return uuid;
}
// PUBNUB

// elasticsearch

if(process.env.VUE_APP_ENTORNO === 'produccion' || process.env.VUE_APP_ENTORNO === 'preproduccion') {
  /*
  Vue.use(ApmVuePlugin, {
    router,
    config: {
      serviceName: 'posventa',
      serverUrl: 'https://apm.prinex.com',
      environment: process.env.VUE_APP_ENTORNO,
      serviceVersion: store.getters.version
      // agent configuration
    }
  })*/
    
  Sentry.init({
    dsn: "https://20adf386ca587ae38749f62fe258b242@o4505560839225344.ingest.sentry.io/4505941353299968",
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/apps.prinex.com\.com/],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}


// elasticsearch

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  render: h => h(App),
  i18n,

  created () {
    this.$store.commit('setMe', {me})
  }
})
